var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVegLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.638672 13.0999V0.899902H12.8387V13.0999H0.638672ZM1.99423 11.7444H11.4831V2.25546H1.99423V11.7444ZM6.73868 9.71102C5.99312 9.71102 5.35488 9.44556 4.82395 8.91463C4.29303 8.38371 4.02756 7.74547 4.02756 6.99991C4.02756 6.25435 4.29303 5.61611 4.82395 5.08519C5.35488 4.55426 5.99312 4.2888 6.73868 4.2888C7.48424 4.2888 8.12248 4.55426 8.6534 5.08519C9.18433 5.61611 9.44979 6.25435 9.44979 6.99991C9.44979 7.74547 9.18433 8.38371 8.6534 8.91463C8.12248 9.44556 7.48424 9.71102 6.73868 9.71102Z",
    fill: "#00CA43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegLogo);
export default __webpack_public_path__ + "static/media/veg-logo.22123f5732328dfdc900f9ee057a7277.svg";
export { ForwardRef as ReactComponent };